import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import EditIcon from '@mui/icons-material/Edit';
import OfficeAddIcon from '../Icons/OfficeAddIcon';
import OfficeDeleteIcon from '../Icons/OfficeDeleteIcon';
import OfficeEditIcon from '../Icons/OfficeEditIcon';


import PropTypes from 'prop-types';

const getIcon = (name, color) => {
    switch (name) {
        case 'Delete':
            return <DeleteIcon fontSize="inherit" color={color} />
            break;
        case 'Add':
            return <AddBoxIcon fontSize="inherit" color={color} />
            break;
        case 'Edit':
            return <EditIcon fontSize="inherit" color={color} />
            break;
        case 'AddOffice':
            return <OfficeAddIcon fontSize="inherit" color={color} />
            break;
        case 'DeleteOffice':
            return <OfficeDeleteIcon fontSize="inherit" color={color} />
            break;
        case 'EditOffice':
            return <OfficeEditIcon fontSize="inherit" color={color} />
            break;
        default:
            return null
    }
}
const AgcIconButton = (props) => {
    let { onClick, tooltip, iconType, iconColor, ...restOfProps } = props;
    return (
        <Tooltip title={tooltip} placement="top">
            <span>
                <IconButton
                    {...restOfProps}
                    size="large"
                    onClick={onClick}>
                    {getIcon(iconType, iconColor)}
                </IconButton>
            </span>
        </Tooltip>
    )
}
AgcIconButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    tooltip: PropTypes.string.isRequired,
    restOfProps: PropTypes.array,
    iconType: PropTypes.string,
    iconColor: PropTypes.string,
};

export default AgcIconButton;
